@if (session$ | async; as session) {
  <lv-session-details
    [session]="session"
    [tokbox]="tokbox"
    [passed]="passed"
    [failed]="failed"
    [retaken]="rejected"
  ></lv-session-details>

  <main>
    @if (liveAgent) {
      <div class="agent-info">
        @switch (step) {
          @case (3) {
            <lv-walk-step-photo></lv-walk-step-photo>
          }
          @case (4) {
            <lv-walk-step-id></lv-walk-step-id>
          }
          @case (5) {
            <lv-walk-step-intro></lv-walk-step-intro>
          }
          @case (6) {
            <lv-walk-step-biometrics></lv-walk-step-biometrics>
          }
          @case (6) {
            <lv-agent-verify-biometrics [session]="session"></lv-agent-verify-biometrics>
          }
          @case (7) {
            <lv-walk-step-complete [session]="session"></lv-walk-step-complete>
          }
        }

        <button class="button is-success is-medium" (click)="next()" [disabled]="!nextEnabled()">
          {{ continueKeyTranslated }}
        </button>
      </div>
    }

    @if (session.idVerified) {
      <lv-agent-verify-attendance [session]="session" [passed]="passed" [failed]="failed"></lv-agent-verify-attendance>
    } @else {
      <lv-agent-verify-id
        [session]="session"
        [passed]="passed"
        [failed]="failed"
        [retaken]="rejected"
      ></lv-agent-verify-id>
    }
  </main>
} @else {
  <div>Loading session...</div>
}
